const seoConfig = {
  // App Details
  appName: "King Data Visualizer",
  developer: "Jeme Beseka",
  version: "3.3",
  
  // Description
  description: "A free Windows desktop application for creating interactive data visualizations from CSV files. Supports 10+ chart types including Line, Bar, Scatter, Pie, Radar, Heatmap, Bubble, Histogram, Box Plot, and Area charts.",
  
  // URLs
  domain: "https://king-datavisualizer.netlify.app",
  downloadUrl: "https://king-datavisualizer.netlify.app/King_Data_Visualizer-3.3.exe",
  ogImage: "https://king-datavisualizer.netlify.app/og-image.png",
  
  // Keywords
  keywords: "King Data Visualizer, King data, King data visualization, Jeme Beseka, free data visualization, data visualization desktop app, CSV chart maker, JavaFX charts, interactive chart maker, free chart software Windows",
  
  // Site Configuration
  siteName: "King Data Visualizer",
  twitterHandle: "@king_jaysheval",
  locale: "en_US",
  themeColor: "#B8860B",
  
  // SEO Defaults
  defaultTitle: "King Data Visualizer — Free Desktop Data Visualization App for Windows",
  defaultDescription: "A free Windows desktop application for creating interactive data visualizations from CSV files. Supports 10+ chart types including Line, Bar, Scatter, Pie, Radar, Heatmap, Bubble, Histogram, Box Plot, and Area charts.",
};

export default seoConfig;
